module.exports = __webpack_public_path__ + "img/cate-4-42635c.png";